<template>
  <ModuleSection title="汇入汇款申报" desc="当您有一笔汇入汇款在途时，请及时提交申报材料，以免影响您的入账进度">
    <p class="inner-declare-tip">{{ $t('超过30天的无效汇入申报将自动变更为申报拒绝，请勿重复提交') }}</p>
    <!-- 电商类汇入汇款待申报列表 -->
    <!-- 根据是否有D类账户 来显示隐藏 而不是是否有D类申报数据 accountInfo.hasMsbdAccount msbdDeclareTableData.length -->
    <!-- 下线电商类账户待申报列表 -->
    <!-- <SubSection title="电商类汇入汇款待申报列表" v-if="accountInfo.hasMsbdAccount">
      <DropDown
        @expand="handleExpand"
        :visibleNum="msbdDeclareTableData.length - msbdDeclareTableMaxRow"
        style="margin-top: 40px;">
        <DataTable
          :data="msbdDeclareTableData"
          :max-row="tableExpand ? msbdDeclareTableMaxRow : 9999"
          :loading="msbdDeclareTableLoading">
          <el-table-column
            :label="$t('生成时间')"
            prop="createTime">
            <template slot-scope="scope">
              <p>{{ scope.row.createTime.split(' ')[0]}}</p>
              <p>{{ scope.row.createTime.split(' ')[1]}}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('账号')"
            prop="accountNo"
            width="180" />
          <el-table-column
            :label="$t('汇款金额')">
            <template slot-scope="scope">
              <p style="color: #F34359;">{{ $_format.toCashWithComma(Number(scope.row.amount)) }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('币种')"
            prop="currency"
            align="center">
            <template slot-scope="scope">
              {{ $t(scope.row.currency) }}
            </template>
            </el-table-column>
          <el-table-column
            :label="$t('汇款人姓名')"
            prop="remitName"/>
          <el-table-column
            :label="$t('申报状态')">
            <template>{{ $t('待申报') }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('操作')">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleMsbdGoDeclare(scope.row)">
                {{ $t('去申报') }}
              </el-link>
            </template>
          </el-table-column>
        </DataTable>
      </DropDown>
    </SubSection> -->
    <!-- 有电商类汇入汇款待申报数据的话 这里添加一个title UI更好看点... -->
    <SubSection :title="accountInfo.hasMsbdAccount ? '汇入汇款申报查询' : ''">
      <!-- 查询表单 -->
      <el-form
        ref="queryForm"
        :model="formData"
        :rules="rules"
        label-position="left"
        :style="accountInfo.hasMsbdAccount ? 'margin-top: 20px;' : ''">
        <el-row style="display: flex;">
          <el-col :span="12" style="margin-right: 40px;">
            <el-form-item
              :label="$t('账号')"
              prop="account">
              <el-select
                v-model="formData.account"
                :placeholder="$t('请选择')"
                style="width:100%">
                <el-option
                  v-for="(item, index) in accountMap"
                  :key="index"
                  :label="item | translateFilter"
                  :value="index" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('申报状态')"
              prop="type">
              <el-select
                v-model="formData.type"
                :placeholder="$t('请选择')"
                style="width:100%">
                <el-option :label="$t('全部')" value="" />
                <el-option
                  v-for="(item, index) in statusMap"
                  :key="index"
                  :label="$t(item)"
                  :value="index" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="display: flex;">
          <el-col :span="12" style="margin-right: 40px;">
            <el-form-item
              :label="$t('开始日期')"
              prop="beginDate">
              <el-date-picker
                type="date"
                v-model="formData.beginDate"
                :placeholder="$t('请选择')"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
                @change="changeStartDate"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('结束日期')"
              prop="endDate">
              <el-date-picker
                type="date"
                v-model="formData.endDate"
                :placeholder="$t('请选择')"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
                @change="changeEndDate"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 查询按钮 -->
      <el-row style="margin: 20px 0 40px;">
        <el-button
          class="btn140"
          type="primary"
          @click="handleQuery">
          {{ $t('查询') }}
        </el-button>
        <el-button
          class="btn140"
          @click="handleGoDeclare">
          {{ $t('去申报') }}
        </el-button>
      </el-row>
      <!-- 查询表格 -->
      <DataTable
        :data="declareTableData"
        :loading="declareTableLoading">
        <el-table-column
          :label="$t('申报时间')"
          prop="reportTime">
          <template slot-scope="scope">
            <p>{{ scope.row.reportTime.split(' ')[0]}}</p>
            <p>{{ scope.row.reportTime.split(' ')[1]}}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('账号')"
          width="150px"
          prop="accNo">
        </el-table-column>
        <el-table-column
          :label="$t('汇款金额')"
          prop="amount">
          <template slot-scope="scope">
            <p style="color: #F34359;">{{ $_format.toCashWithComma(scope.row.amount) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('币种')"
          prop="currency">
          <template slot-scope="scope">
            <p>{{ $t($_params.GRB_CURRENCY_TYPE[scope.row.currency]) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('汇款用途')"
          prop="purpose">
        </el-table-column>
        <el-table-column
          :label="$t('申报状态')"
          prop="status">
          <template slot-scope="scope">
            <p>{{ $t(declareStatusMap[scope.row.status]) }}</p>
            <p
              v-if="scope.row.status === 'PASS' || scope.row.status === 'PASS2'"
              style="color: #999;">
              {{ $t('近期请关注账户入金') }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('操作')"
          width="160">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="handleViewDetail(scope.row)">
              {{ $t(scope.row.status === 'REJECT' ? '重新提交' : '查看详情') }}
            </el-link>
          </template>
        </el-table-column>
      </DataTable>
      <!-- 分页 -->
      <Pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :total="total"
        layout="prev, pager, next, jumper" />
      </SubSection>
  </ModuleSection>
</template>

<script>
import { mapState } from 'vuex'
import declareApi from './api'
import { declareStatusMap } from './constants'
export default {
  name: 'DeclareInnerQueryCache',
  components: {},
  data () {
    const statusMap = this.$_format.getFilterObj(declareStatusMap, ['WAIT', 'PASS', 'REJECT'])
    return {
      /* 电商类表格 */
      // msbdDeclareTableData: [],
      // msbdDeclareTableMaxRow: 2,
      // msbdDeclareTableLoading: false,
      /* 查询表单 */
      accountMap: {},
      // 筛选出 审核中 审核通过 审核拒绝
      declareStatusMap,
      statusMap,
      formData: {
        account: '',
        type: '',
        beginDate: '',
        endDate: ''
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      /* 查询表格 */
      declareTableData: [],
      declareTableLoading: false,
      /* 分页 */
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableExpand: true
    }
  },
  computed: {
    ...mapState('account', ['accountInfo']),
    rules () {
      return {
        beginDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        endDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.formData.endDate = this.$_format.getToday()
    this.formData.beginDate = this.$_format.getLastDay(this.formData.endDate, 7)
    // this.accountMap = this.$_params.getSessionAccountSelect_obj_hasD_new('ALL', true, 0, 0)
    // 列表数据不再包含电商类账户 因为上面的电商类待申报列表已下线
    this.accountMap = this.$_params.getSessionAccountSelect_obj_only(/\|S$/, 'ALL', true, 0, 0) || []
    this.initParamsFormQuery()
  },
  activated () {
    // 下线电商类账户待申报列表
    // this.getMsbdDeclareTableData()
    this.getDeclareTableData()
  },
  methods: {
    // 时间控件
    changeStartDate () {
      const beginDateStamp = new Date(this.formData.beginDate).getTime()
      const endDateStamp = new Date(this.formData.endDate).getTime()
      if (beginDateStamp > endDateStamp) {
        this.formData.endDate = ''
      }
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          return time.getTime() < beginDateStamp
        }
      })
    },
    changeEndDate () {
      const beginDateStamp = new Date(this.formData.beginDate).getTime()
      const endDateStamp = new Date(this.formData.endDate).getTime()
      if (endDateStamp < beginDateStamp) {
        this.formData.beginDate = ''
      }
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          return time.getTime() > new Date(this.formData.endDate).getTime()
        }
      })
    },
    initParamsFormQuery () {
      const { accountNo } = this.$route.query
      const accountList = Object.keys(this.accountMap)
      if (accountNo) {
        const account = accountList.filter(item => item.startsWith(accountNo))[0]
        if (account) {
          this.formData.account = account
        }
      } else {
        const account = accountList[0]
        this.formData.account = account
      }
    },
    /* 电商类表格 */
    // getMsbdDeclareTableData () {
    //   if (!this.accountInfo.hasMsbdAccount) return
    //   this.msbdDeclareTableLoading = true
    //   return declareApi.getMsbdDeclareTableData().then(res => {
    //     this.msbdDeclareTableLoading = false
    //     if (res) {
    //       this.msbdDeclareTableData = res
    //     }
    //   }).catch(err => {
    //     this.msbdDeclareTableLoading = false
    //     console.error(err)
    //   })
    // },
    // 电商类账户 去申报
    handleMsbdGoDeclare (row) {
      const { id: reportId } = row
      this.$router.push({
        name: 'DeclareInnerMsbdAdd',
        query: {
          type: 'Add',
          reportId
        }
      })
    },
    // 伸缩
    handleExpand (expand) {
      this.tableExpand = expand
      // if (expand) {
      //   this.msbdDeclareTableMaxRow = 2
      // } else {
      //   this.msbdDeclareTableMaxRow = this.msbdDeclareTableData.length
      // }
    },
    /* 表单按钮 */
    // 去申报
    handleGoDeclare () {
      this.$router.push({
        name: 'DeclareInnerAdd',
        query: {
          type: 'Add'
        }
      })
    },
    // 查询
    getDeclareTableData () {
      const { formData, pageNum, pageSize } = this
      const accountResult = formData.account.split('|')
      this.declareTableLoading = true
      return declareApi.getDeclareTableData({
        ...formData,
        account: accountResult[0],
        accountType: accountResult[4],
        pageNum,
        pageSize,
        currentBusinessCode: '10101300'
      }).then(res => {
        this.declareTableLoading = false
        if (res) {
          const { list, totalSize } = res
          this.declareTableData = list
          this.total = totalSize
        }
      }).catch(err => {
        this.declareTableLoading = false
        console.error(err)
      })
    },
    handleQuery () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.pageNum = 1
          this.getDeclareTableData()
        }
      })
    },
    /* 查询表格 */
    // 查看详情
    handleViewDetail (row) {
      const { accNo, reportId } = row
      this.$router.push({
        name: /MSBD/.test(this.formData.account) ? 'DeclareInnerMsbdDetail' : 'DeclareInnerDetail',
        query: {
          type: 'Detail',
          accNo,
          reportId
        }
      })
    },
    /* 分页 */
    handleSizeChange () {
      this.getDeclareTableData()
    },
    handleCurrentChange () {
      this.getDeclareTableData()
    }
  }
}
</script>

<style scoped lang="less">
.btn140 {
  min-width: 140px;
}
.inner-declare-tip {
  margin-top: -30px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  color: #a1a7c4;
  line-height: 14px;
}
</style>
